<template>
  <v2-table
    url="/api/v1/emailLog?paginate"
    :headers="[
      {
        text: 'Id'
      },
      {
        text: 'User'
      },
      {
        text: 'Betreff'
      },
      {
        text: 'Typ'
      },
      {
        text: 'Datum'
      },
      {
        text: 'Nachricht'
      }
    ]"
  >
    <template slot="filter">
      <date-range-filter titel="Zeitraum" name="created_at_between" />
      <basic-filter titel="E-Mail-Adresse" name="to"></basic-filter>
    </template>
    <tr slot="row" slot-scope="{ item }">
      <td>{{ item.id }}</td>
      <e-mail-log-to-cell :model="item" :content="item.to"></e-mail-log-to-cell>
      <td>{{ item.subject }}</td>
      <td>{{ item.type }}</td>
      <date-time-cell :content="item.created_at" />
      <modal-cell
        :attribute="{ mode: 'emailLog', modal: 'EMailLogModal' }"
        :model="item"
      />
    </tr>
  </v2-table>
</template>

<script lang="babel">
import DateRangeFilter from "@/components/v2filter/DateRangeFilter.vue";
import BasicFilter from "@/components/v2filter/BasicFilter.vue";
import EMailLogToCell from "@/components/table/EMailLogToCell";
import DateTimeCell from "@/components/table/DateTimeCell";
import ModalCell from "@/components/table/ModalCell";
export default {
  components: {
    DateRangeFilter,
    BasicFilter,
    EMailLogToCell,
    DateTimeCell,
    ModalCell
  }
};
</script>
